import { getUrlParam } from '@/lib/utils';
import Record from '@/lib/record';

const pageIds = {
  '/messageDetail': 'cloud-download-page',
  '/cloudProduct': 'cloud-product-page',
  '/cloudDownload': 'cloud-download-page',
  '/cloudMessage': 'cloud-news-page',
  '/': 'cloud-download-page',
};

const downloadPayload = {
  '/messageDetail': {
    pageId: 'cloud-message-detail-page',
    name: 'cloud-message-detail-click',
  },
  '/cloudMessage': {
    pageId: 'cloud-message-page',
  },
};
function defaultDownloadPayload() {
  return {
    pageId: pageIds[window.location.pathname],
    name: 'cloud-download-click',
    activity_code: getUrlParam('activity_code'),
  };
}

function pageView() {
  const pageId = pageIds[window.location.pathname];
  if (!pageId) return;
  Record.sendPV({
    pageId,
    activity_code: getUrlParam('activity_code'),
  });
}

function downloadClick(option) {
  const pagePayload = downloadPayload[window.location.pathname];
  const payload = Object.assign(defaultDownloadPayload(), pagePayload, option);
  Record.moduleClick(payload);
}

export {
  pageView,
  downloadClick,
};



// WEBPACK FOOTER //
// ./src/components/layout-common/pageRecord.js